import type {
  LoginInput,
  LoginResult,
  LogoutResult,
  MfaLoginResult,
  MfaVerifyEmailInput,
  UserInfoResult,
} from '@vivport/backend/types/auth';
import type { MessageResult } from '@vivport/backend/types/common';

import { httpClient } from './http-client';

export function login(input: LoginInput): Promise<LoginResult | MfaLoginResult> {
  return httpClient.post<LoginResult | MfaLoginResult, LoginInput>('/auth/login', input);
}

export function mfaSendEmailCode(mfaToken: string): Promise<MessageResult> {
  return httpClient.post<MessageResult, { mfaToken: string }>('/auth/mfa/send-email-code', { mfaToken });
}

export function mfaVerifyEmail(input: MfaVerifyEmailInput): Promise<LoginResult> {
  return httpClient.post<LoginResult, MfaVerifyEmailInput>('/auth/mfa/verify-email', input);
}

export function logout(refreshToken: string): Promise<LogoutResult> {
  return httpClient.post<LogoutResult, { refreshToken: string }>('/auth/logout', { refreshToken });
}

export function getUser(): Promise<UserInfoResult> {
  return httpClient.get<UserInfoResult>('/auth/user');
}
